var _a, _b;
// replace the user pool region, id, and app client id details
var config = {
    REGION: process.env.COGNITO_REGION,
    USER_POOL_ID: (_a = process.env.COGNITO_USER_POOL_ID) !== null && _a !== void 0 ? _a : '',
    USER_POOL_APP_CLIENT_ID: (_b = process.env.COGNITO_CLIENT_ID) !== null && _b !== void 0 ? _b : '',
    DOMAIN: process.env.COGNITO_DOMAIN,
};
export default config;
